module.exports = __webpack_public_path__ + "img/nullpic.7e1bc39f.png";